import PropTypes from 'prop-types';
import React from 'react';

import './Barchart.scss';

export default class Barchart extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {
        //Data, this is required
        data: PropTypes.arrayOf(
            PropTypes.shape({
                title: PropTypes.string,
                value: PropTypes.number,
            })
        ).isRequired,
        //The height you want at 100%, defaults to 150
        totalHeight: PropTypes.number,
        //Widht you want the bars to be (Number in px)
        width: PropTypes.number,
        //If you want a specific one to be highlighted, set this to the title for that section
        highestSectionLabel: PropTypes.string,
        // color that is for all unless highlighted
        majorityColor: PropTypes.string,
        // color for highlighted bar
        highlightedColor: PropTypes.string,
        //Width for labels, this is so that the bars line up at the bottom.
        labelWidth: PropTypes.number,
    };

    static defaultProps = {
        width: 34,
        totalHeight: 400,
        majorityColor: '#decefd',
        highlightedColor: '#982ea9',
        labelWidth: 40,
    };

    calculateHeight = (number) => {
        const tenth = Math.ceil(Number(number) * 0.01 * 100) / 100;
        return tenth * this.props.totalHeight;
    };

    render() {
        return (
            <div className="component-Charts-Barchart">
                {this.props.data.map((singleBar) => {
                    const colorDecision =
                        singleBar.title === this.props.highestSectionLabel
                            ? this.props.highlightedColor
                            : this.props.majorityColor;
                    return (
                        <div
                            key={singleBar.title}
                            className="single-bar"
                            style={{ width: `${this.props.width}px` }}
                        >
                            <div
                                className="single-bar-percentage-display"
                                style={{ width: `${this.props.labelWidth}` }}
                            >{`${singleBar.value}%`}</div>
                            <div
                                className="color"
                                style={{
                                    width: '100%',
                                    height: `${this.calculateHeight(
                                        singleBar.value
                                    )}px`,
                                    backgroundColor: `${colorDecision}`,
                                }}
                            />
                            <div
                                className="title"
                                style={{ width: `${this.props.labelWidth}px` }}
                            >
                                {singleBar.title}
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}
